export const en = {
    "save-flags": "Save flags",
    "title-app-flags": "App feature flags",
    "title-skill-feature-flags": "Skill feature flags",
    "title-user-feature-flags": "User feature flags",
    "app-flags-subtitle": "App and user Flags"
} as const;
export const ru = {    
    "save-flags": "Сохранить флаги",
    "title-app-flags": "Флаги приложения",
    "title-skill-feature-flags": "Флаги навыка",
    "title-user-feature-flags": "Флаги пользователя",
    "app-flags-subtitle": "Флаги приложения и пользователя"
} as const;
